
(function () {
  function initDRIDropdowns() {
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown]'));

    function closeAll(except) {
      dropdowns.forEach(function (drop) {
        if (drop === except) return;
        var btn = drop.querySelector('.jsdrop-toggle');
        var menu = drop.querySelector('.jsdrop-menu');
        if (btn && menu) {
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          drop.classList.remove('is-open');
        }
      });
    }

    dropdowns.forEach(function (drop) {
      var btn = drop.querySelector('.jsdrop-toggle');
      var menu = drop.querySelector('.jsdrop-menu');
      if (!btn || !menu) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var willOpen = menu.hidden;
        closeAll(drop);
        menu.hidden = !willOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        drop.classList.toggle('is-open', willOpen);
      });

      menu.addEventListener('click', function (e) {
        e.stopPropagation();
        // Intentionally do not preventDefault so links navigate.
      });
    });

    document.addEventListener('click', function () {
      closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDRIDropdowns);
  } else {
    initDRIDropdowns();
  }
})();
